import { useEffect, useState } from 'react'
import { SliderItem } from './types'
import { SLIDER_INTERVAL } from './constants'

export const useSlider = (items: SliderItem[]) => {
  const [activeItem, setActiveItem] = useState<SliderItem>(
    items[0] || { title: '', description: '' },
  )
  const [currentIndex, setCurrentIndex] = useState(0)

  useEffect(() => {
    if (items.length === 0) return

    const timer = setInterval(() => {
      setCurrentIndex((prevIndex) => {
        const newIndex = (prevIndex + 1) % items.length
        setActiveItem(items[newIndex])
        return newIndex
      })
    }, SLIDER_INTERVAL)

    return () => clearInterval(timer)
  }, [items])

  const handleItemClick = (item: SliderItem, index: number) => {
    if (item) {
      setActiveItem(item)
      setCurrentIndex(index)
    }
  }

  return {
    activeItem,
    currentIndex,
    handleItemClick,
  }
}
